import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FontsService } from '../../../services/fonts/fonts.service';
import { NotyService } from '../../../services/common/noty.service';
import { FileUploader } from 'ng2-file-upload';
@Component({
  selector: 'app-font-show',
  templateUrl: './font-show.component.html',
  styleUrls: ['./font-show.component.scss'],
})
export class FontShowComponent implements OnInit {
  fontId: Number;
  font: any = {};
  shouldUpdate: Boolean = false;
  changeFontFiles: Boolean = false;
  updatedFontName: String = '';
  updatedFontDesc: String = '';
  regUploader: FileUploader;
  boldUploader: FileUploader;
  italicUploader: FileUploader;
  boldItalicUploader: FileUploader;
  formSubmitting: Boolean = false;
  formSubmitted: Boolean = false;
  isFontDefault: Boolean = false;
  constructor(private fontsService: FontsService, private route: ActivatedRoute, private notyService: NotyService) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.fontId = params.id;
    });
    this.initializeUploader();
    this.loadFont();
  }
  initializeUploader() {
    this.regUploader = new FileUploader({ itemAlias: 'r_file', url: 'fonts/${this.fontId}.json' });
    this.regUploader.onAfterAddingFile = () => {
      if (this.regUploader.queue.length > 1) {
        let uploadQueue: any = this.regUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.boldUploader = new FileUploader({ itemAlias: 'b_file', url: 'fonts/${this.fontId}.json'  });
    this.boldUploader.onAfterAddingFile = () => {
      if (this.boldUploader.queue.length > 1) {
        let uploadQueue: any = this.boldUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.italicUploader = new FileUploader({ itemAlias: 'i_file', url: 'fonts/${this.fontId}.json'  });
    this.italicUploader.onAfterAddingFile = () => {
      if (this.italicUploader.queue.length > 1) {
        let uploadQueue: any = this.italicUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
    this.boldItalicUploader = new FileUploader({ itemAlias: 'bi_file', url: 'fonts/${this.fontId}.json'  });
    this.boldItalicUploader.onAfterAddingFile = () => {
      if (this.boldItalicUploader.queue.length > 1) {
        let uploadQueue: any = this.boldItalicUploader.queue;
        let len: number = uploadQueue.length;
        uploadQueue.splice(0, len - 1);
      }
    };
  };

  uploadFont(formValid: boolean) {
    this.formSubmitted = true;
    if (this.regUploader.queue[0] && formValid) {
      this.regUploader.queue[0].method = 'PUT';
      this.regUploader.queue[0].url = `fonts/${this.fontId}.json`;
      this.regUploader.queue[0].upload();
    }
    if (this.boldUploader.queue[0] && formValid) {
      this.boldUploader.queue[0].method = 'PUT';
      this.boldUploader.queue[0].url = `fonts/${this.fontId}.json`;
      this.boldUploader.queue[0].upload();
    }
    if (this.italicUploader.queue[0]) {
      this.italicUploader.queue[0].method = 'PUT';
      this.italicUploader.queue[0].url = `fonts/${this.fontId}.json`;
      this.italicUploader.queue[0].upload();
    }
    if (this.boldItalicUploader.queue[0]) {
      this.boldItalicUploader.queue[0].method = 'PUT';
      this.boldItalicUploader.queue[0].url = `fonts/${this.fontId}.json`;
      this.boldItalicUploader.queue[0].upload();
    }
    window.setTimeout(() => {
      console.log('setTimeout', this);
      this.notyService.notify('Font files uploaded', 'success');
      this.formSubmitted = false;
      this.changeFontFiles = false;
      this.loadFont();
    }, 5000);
  }

  loadFont() {
    this.fontsService
      .show({ fontId: this.fontId })
      .then((fontShowRe) => {
        console.log('fontShowRe', fontShowRe);
        this.font = fontShowRe.font;
        this.updatedFontName = this.font.name;
        this.updatedFontDesc = this.font.description;
        this.injectFontCss(fontShowRe.font.font_css);
      })
      .catch((fontShowEr) => {
        console.log('fontShowEr', fontShowEr);
      });
  };

  injectFontCss(fontCss: string) {
    const style = document.createElement('style');
    style.innerHTML = fontCss;
    document.body.appendChild(style);
  };

  updateFont() {
    this.formSubmitting = true;
    this.fontsService
      .update({ fontId: this.fontId, name: this.updatedFontName, description: this.updatedFontDesc, default_font: this.isFontDefault })
      .then((updateRe) => {
        this.notyService.notify('Font updated', 'success');
        this.loadFont();
        this.shouldUpdate = false;
        this.formSubmitting = false;
      })
      .catch((updateEr) => {
        console.log('updateEr', updateEr);
        this.notyService.notify('Error updating font', 'error');
      });
  };
}
